import { Children } from 'react';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { SwitchProps } from './JSXSwitch.types';
import { CaseProps } from '../JSXCase/JSXCase.types';

/**
 * This is a switch statement for JSXCase components.  The first that evaulates to true is built.
 * All others are ignored.
 *
 * @param children - {@link SwitchProps.children children} description.
 *
 * @example
 * <JSXSwitch>
 *    <JSXCase Condition={false}>
 *        //I will not render cause I am false.
 *    </JSXCase>
 *    <JSXCase Condition={true}>
 *        //I will render cause I am the first true.
 *    </JSXCase>
 *    <JSXCase Condition={true}>
 *        //I will not render cause I am not the first true.
 *    </JSXCase>
 *    <JSXCase Default>
 *        //I will render by default if no previous condition is true.
 *    </JSXCase>
 * </JSXSwitch>
 */
const JSXSwitch: GoMotoComponent<SwitchProps> = (props) => {
    let matchingElementFound: boolean = false;
    let matchingElement: JSX.Element | null = null;

    Children.forEach(props.children, function (element) {
        const caseProps: CaseProps = element.props;
        if (!matchingElementFound && (caseProps.default || caseProps.condition)) {
            matchingElementFound = true;
            matchingElement = element;
        }
    });

    if (!matchingElementFound) {
        return null;
    }

    return matchingElement;
};

export default JSXSwitch;